import * as React from 'react';
import {Modal} from "../../Modal";
import Button from "../../Button";
import './CreateEditSeedIconModal.css';
import { ISeedCategory, ISeedIcon } from '../../../infrastructure/interfaces'
import { ImageFileTypes } from '../../../infrastructure/ImageFileTypes'
import { contentImagesRelativePath } from '../../../constants';
import DropdownMenu, { IDropdownMenuOption } from 'src/components/DropdownMenu/DropdownMenu';

export interface CreateEditSeedIconProps {
    show: boolean;
    seedCategories: ISeedCategory[];
    onClose: any;
    seedIcon?: ISeedIcon;
    editSeedIcon(seedIcon: ISeedIcon, formData?: FormData): void
    createSeedIcon(iconName: string, category: ISeedCategory, formData: FormData): void;
}

export interface CreateEditSeedIconState {
    formData?: FormData;
    seedIconName: string;
    hasRequiredFields: boolean;
    seedCategory?: ISeedCategory;
}

export default class CreateEditSeedIconModal extends React.Component<CreateEditSeedIconProps, CreateEditSeedIconState> {

    constructor(props: any) {
        super(props);

        this.state = {
            formData: undefined,
            seedIconName: (props.seedIcon) ? props.seedIcon.name : '',
            hasRequiredFields: false,
        };
        this.onSave = this.onSave.bind(this);
    }

    componentWillReceiveProps(nextProps: any) {
        const newIconName = (nextProps.seedIcon) ? nextProps.seedIcon.name : '';
        this.setState({
            seedIconName: newIconName,
            hasRequiredFields: newIconName.length > 0
        });
    }

    getSelectedSeedCategory = (): ISeedCategory | undefined => {
        
        if (this.state.seedCategory) {
            return this.state.seedCategory;
        }
        if (this.props.seedIcon) {
            return this.props.seedIcon.category;
        }
        return undefined;
    }

    updateSeedIcon = () => {

        const seedCategory = this.getSelectedSeedCategory();
        if (seedCategory == undefined) {
            return;
        }

        if (this.props.seedIcon && this.props.seedIcon.id) {
            if (this.props.editSeedIcon) {
                const updatedSeedIcon: ISeedIcon = {...this.props.seedIcon,
                    name: this.state.seedIconName,
                    category: seedCategory
                }
                this.props.editSeedIcon(updatedSeedIcon, this.state.formData);
            }
        } else {
            if (!this.state.formData) {
                return;
            }
            if (this.props.createSeedIcon) {
                this.props.createSeedIcon(this.state.seedIconName, seedCategory, this.state.formData);
            }
        }
    }

    handleChangeSeedIcon(selectorFiles: FileList | null)
    {
        if (selectorFiles != null) {
            for (var key in selectorFiles) {
                var formData = new FormData();
                formData.set(ImageFileTypes.SEED_ICON, selectorFiles[key]);
                this.setState({formData},
                    () => this.hasValidFields());
                break;
            }
        }
    }

    onSave() {
        this.updateSeedIcon();
        this.closeModal();
    }

    handleInputGroupChange(newIconName: string) {
        this.setState({
            seedIconName: newIconName
        }, () => this.hasValidFields());
    }

    hasValidFields() {
        const hasValidText = (this.state.seedIconName.length > 1);
        const hasValidImages = (this.props.seedIcon)
            ? true
            : (
                (this.state.formData != undefined)
                && (this.state.formData.get(ImageFileTypes.SEED_ICON) != null)
              )
        const seedCategory = this.getSelectedSeedCategory();
        const hasSeedCategory = seedCategory != undefined;
        this.setState({ hasRequiredFields: (hasValidText && hasValidImages && hasSeedCategory) });
    }

    closeModal() {
        this.setState({
            seedIconName: '',
            seedCategory: undefined,
        });
        this.props.onClose();
    }

    createSeedCategoryList(): IDropdownMenuOption[] {
        var seedCategoryList =
            this.props.seedCategories.map((p) => {
                return {
                    title: p.name,
                    onClick: () => {
                        this.setState({ seedCategory: p },
                            () => this.hasValidFields());
                    },
                };
            });

        return seedCategoryList;
    }

    render() {
        const seedCategory = this.getSelectedSeedCategory();
        const seedCategoryText = seedCategory ? seedCategory.name : "Select Seed Category";

        return (
            <Modal show={this.props.show}
                   onClose={() => {this.closeModal();}}
            >
                <Modal.Header>
                    <Modal.Title>
                        <h5>
                            {this.props.seedIcon ? this.props.seedIcon.name : 'Upload Trait Logo'}
                        </h5>
                    </Modal.Title>
                    <Button bsClass="close" onClick={() => {this.closeModal();}}></Button>                        
                </Modal.Header>
                <Modal.Body>
                    <div className="seedIconContainer">
                        <div className="seedIconInputContainer">
                            <div>
                                <b>Icon Name:  </b>
                                <input
                                    placeholder="Icon Name"
                                    maxLength={100}
                                    value={this.state.seedIconName}
                                    onChange={e => {
                                        this.handleInputGroupChange(e.target.value);
                                    } }/>
                            </div>
                        </div>

                        <div className="seedIconInputContainer">
                            <b>Seed Category: </b>
                            <div>
                                <DropdownMenu
                                    title={ seedCategoryText }
                                    options={this.createSeedCategoryList()}
                                    extraWide={true}
                                />
                            </div>
                        </div>

                        <div className="seedIconInputContainer">
                            <label>
                                <b>Image</b>
                            </label>
                            {
                                (this.props.seedIcon)
                                    ? <div className="seedIconImageContainer"><img className="editImageModalImage" src={contentImagesRelativePath + this.props.seedIcon.src} /></div>
                                    : <div></div>
                            }
                            <input type="file"
                                   className="filepond"
                                   multiple={false}
                                   onChange={(e) => this.handleChangeSeedIcon(e.target.files)} />
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button bsClass="cancel" onClick={() => {this.closeModal();}}>
                        Cancel
                    </Button>
                    <Button
                        bsClass="primary"
                        disabled={!this.state.hasRequiredFields}
                        onClick={() => {
                            this.onSave();
                        }}
                    >
                        Save Changes
                    </Button>
                </Modal.Footer>
            </Modal>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Modals/CreateEditSeedIconModal/CreateEditSeedIconModal.tsx